import React from 'react';
import Border from '../Border';
import { Padding } from '../layout-components';
import SearchInput from '../../SearchInput';

const TableSearch = ({
  enabled = false,
  borderProps,
  placeholder,
  setValue,
  value
}) =>
  enabled ? (
    <Border {...borderProps} height='auto'>
      <Padding b='small'>
        <SearchInput
          height='3.5rem'
          width='96%'
          variant='outlined'
          onChange={setValue}
          value={value}
          placeholder={placeholder}
        />
      </Padding>
    </Border>
  ) : null;

export default TableSearch;
